import { useEffect } from "react";

import { useMap } from "react-leaflet";
import L from "leaflet";
function DefaultGreekLayer(zipUrl) {
  let areas = []
  // Setting Default
  let layer_type = 'Περιφερειακές Ενότητες (NUTS3)';
  if (zipUrl['areas'].length !== 0 ) {
    layer_type = zipUrl['areas'][0]["group"];
  }
  zipUrl['areas'].forEach((area) => {
      areas.push(area.label);
      layer_type = area.group;
    }
  )
  console.log(layer_type)
  const map = useMap()
  
  function preparePolygonData(region_obj, name_property) {
    let data_features = []
    for (let i = 0; i < region_obj["features"].length; i++) {
      let item = region_obj["features"][i]
      let elem = {
        "type": item["type"],
        "properties": {
          "name": item["properties"][name_property],
        },
        "geometry": item["geometry"]
      }
      data_features.push(elem)
    }
    return data_features
  }

  function prepareCoordinateData(region_obj, name_property) {
    // console.log(region_obj)
    console.log(areas)
    let data_features = []
    for (let i = 0; i < region_obj["features"].length; i++) {
        if (areas.includes(region_obj["features"][i]["properties"][name_property])) {
          let item = region_obj["features"][i]
          console.log(item["geometry"]["coordinates"])
          let elem = {
            "type": item["type"],
            "properties": {
              "name": item["properties"][name_property],
            },
            "geometry": {
              "type": "Point",
              "coordinates": item["geometry"]["coordinates"]
            }
          }
          data_features.push(elem)
        }
      }
    return data_features
  }
  const create_region_layer = preparePolygonData(zipUrl["zipUrl"], "NUTS_NAME")
  const create_dim_layer = preparePolygonData(zipUrl["dim"], "Name")
  const create_oik_layer = prepareCoordinateData(zipUrl["oik"], "Name")

  function style(feature) {
    return {
      fillColor: "#F9FAFB",
      opacity: 1,
      weight: 1,
      color: '#0F8DD6',
      fillOpacity: 1
    };
  }

  function styleOik(feature) {
    return {
      fillColor: "#0F8DD6",
      opacity: 0,
      weight: 0,
      color: '#0F8DD6',
      fillOpacity: 0
    };
  }
  const onEachFeaturePoint = (point, layer) => {
    const pointName = point.properties.name;
    if (areas.includes(pointName) ) {
      console.log(pointName)
      layer.setStyle({opacity :1, weight:1, fillOpacity:1});
    }
  }
  const onEachFeatureReg = (region, layer) => {
    const regionName = region.properties.name;

    // console.log(active)
    if (areas.includes(regionName) ) {
      // console.log(regionName)
      layer.setStyle({fillColor :'#0F8DD6'});
    }

    layer.bindPopup(regionName)
  }
  useEffect(() => {
    if (layer_type == "Περιφερειακές Ενότητες (NUTS3)") {
      // Region Layer
      L.geoJson(create_region_layer, { style: style , onEachFeature:onEachFeatureReg }).addTo(map);
    } else if (layer_type == "Δήμοι"){
      // Dim Layer
      L.geoJson(create_dim_layer, { style: style , onEachFeature:onEachFeatureReg }).addTo(map);
    } else if (layer_type == "Οικισμοί") {
      const oik_layer = L.geoJson(create_oik_layer, { style: styleOik, onEachFeature:onEachFeaturePoint, pointToLayer: function (feature, latlng) {return L.circleMarker(latlng, {radius: 3,});} }).addTo(map);
    }

  }, [zipUrl['areas']]);
  return null
}


export default DefaultGreekLayer;